export default __webpack_public_path__ + "static/media/vid.84bebb3a.mp4";